import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { NotificationSettingsPage } from 'pages/notification-settings/notification-settings-page';

@NgModule({
  declarations: [NotificationSettingsPage],
  imports: [PagesModule, ComponentsModule],
})
export class NotificationSettingsPageModule {}
